import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgIconPlaybackRate05X = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 14, viewBox: "0 0 28 14", fill: "none", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.67669 14C2.15618 14 1.7097 13.8183 1.33727 13.4548C0.969317 13.0869 0.787586 12.6404 0.792073 12.1154C0.787586 11.6038 0.969317 11.1663 1.33727 10.8029C1.7097 10.4394 2.15618 10.2577 2.67669 10.2577C3.17028 10.2577 3.60553 10.4394 3.98246 10.8029C4.36387 11.1663 4.55682 11.6038 4.5613 12.1154C4.55682 12.4654 4.46483 12.784 4.28534 13.0712C4.11034 13.3538 3.8815 13.5804 3.5988 13.751C3.31611 13.917 3.00874 14 2.67669 14Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M11.1251 13.9731C10.0662 13.9731 9.12611 13.7869 8.30496 13.4144C7.48829 13.0375 6.84438 12.5192 6.37323 11.8596C5.9802 11.3041 5.74949 10.6785 5.68111 9.98296C5.65961 9.76432 5.8391 9.58461 6.05879 9.58461H8.91053C9.12426 9.58461 9.29263 9.75727 9.34648 9.9641C9.42521 10.2665 9.59181 10.5192 9.8463 10.7221C10.2053 11.0048 10.6316 11.1462 11.1251 11.1462C11.5066 11.1462 11.8431 11.0654 12.1348 10.9038C12.4264 10.7378 12.6553 10.5045 12.8213 10.2038C12.9873 9.90321 13.0681 9.55321 13.0636 9.15385C13.0681 8.75 12.9873 8.4 12.8213 8.10385C12.6553 7.80321 12.4264 7.57212 12.1348 7.41058C11.8431 7.24455 11.5066 7.16154 11.1251 7.16154C10.7303 7.16154 10.3646 7.25801 10.028 7.45096C9.78981 7.58617 9.59662 7.75949 9.44847 7.97092C9.34427 8.11962 9.16922 8.21384 8.99106 8.17879L6.35211 7.65965C6.15658 7.62119 6.02035 7.44306 6.03445 7.24427L6.5222 0.366937C6.53686 0.160214 6.70884 0 6.91609 0H15.4149C15.633 0 15.8098 0.17679 15.8098 0.394872V2.59359C15.8098 2.81167 15.633 2.98846 15.4149 2.98846H9.97893C9.77434 2.98846 9.60363 3.14473 9.58559 3.34852L9.3528 5.97912C9.35034 6.00688 9.37221 6.03077 9.40008 6.03077C9.41784 6.03077 9.43407 6.02084 9.44245 6.00518C9.65973 5.59932 10.0277 5.26233 10.5463 4.99423C11.0758 4.71603 11.6905 4.57692 12.3905 4.57692C13.2117 4.57692 13.9431 4.76763 14.5848 5.14904C15.2309 5.53045 15.7402 6.05769 16.1127 6.73077C16.4896 7.39936 16.6758 8.17115 16.6713 9.04615C16.6758 10.0064 16.4469 10.859 15.9848 11.6038C15.5271 12.3442 14.8832 12.9253 14.053 13.3471C13.2229 13.7644 12.2469 13.9731 11.1251 13.9731Z", fill: props.fill }), /* @__PURE__ */ React.createElement("path", { d: "M20.3175 3.44615C20.4705 3.44615 20.6097 3.53449 20.6748 3.67289L21.7278 5.91047C21.8684 6.20939 22.2921 6.21372 22.4388 5.91774L23.5554 3.66562C23.6221 3.53119 23.7592 3.44615 23.9092 3.44615H26.6928C26.9913 3.44615 27.1818 3.76464 27.0407 4.02769L24.6822 8.42421C24.6183 8.54327 24.6197 8.68671 24.686 8.80447L27.1563 13.1962C27.3044 13.4594 27.1141 13.7846 26.8121 13.7846H24.0628C23.9169 13.7846 23.7829 13.7042 23.7143 13.5754L22.4297 11.1644C22.28 10.8834 21.8765 10.886 21.7304 11.1688L20.49 13.5709C20.4222 13.7022 20.2868 13.7846 20.1391 13.7846H17.3425C17.0398 13.7846 16.8496 13.458 16.9991 13.1948L19.4918 8.80402C19.5585 8.68654 19.5605 8.54312 19.4971 8.42382L17.1609 4.02628C17.0212 3.76328 17.2118 3.44615 17.5096 3.44615H20.3175Z", fill: props.fill }));
});
export default SvgIconPlaybackRate05X;
